import type { ReactNode } from "react";

import styles from "./Page.module.css";
import { JOURNEY_ENABLED } from "@/components/nitro/config";

interface Props {
  children: ReactNode;
  withTopPadding?: boolean;
  /** Exclude legal and non-content pages from Journey auto placements. */
  disableJourneyContent?: boolean;
}

export function Page({ children, withTopPadding = false, disableJourneyContent = false }: Props) {
  return (
    <main className={`${styles.page} ${withTopPadding ? styles.withTopPadding : ""}${JOURNEY_ENABLED && !disableJourneyContent ? " journey-content" : ""}`}>
      {children}
    </main>
  );
}